import { render, staticRenderFns } from "./MsinEditAppr.vue?vue&type=template&id=4fbf9f20&scoped=true&"
import script from "./MsinEditAppr.vue?vue&type=script&lang=js&"
export * from "./MsinEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbf9f20",
  null
  
)

export default component.exports